import React from "react";
import { SERVICES } from "@/lib/site";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import { ServiceCard } from "@/components/landing/ServiceCard";

const Disclaimer = () => (
  <p className="mt-3 max-w-4xl text-xs leading-relaxed text-slate-500">
    Moruya Travel Solutions is not a government authority or an embassy; visa decisions
    are made solely by the relevant immigration authorities. Insurance products are
    underwritten and issued by licensed insurer partners.
  </p>
);

export const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="scroll-mt-32 lg:scroll-mt-40 bg-white lg:flex lg:min-h-screen lg:items-start pb-10 pt-6 sm:pb-14 sm:pt-8 lg:py-6"
  >
    <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="Our activities"
        title="Three activities held by the group"
        description="The three areas the group builds and holds, shown here for information."
      />

      <div className="mt-6 grid grid-cols-1 gap-4 sm:mt-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-5">
        {SERVICES.map((service, index) => (
          <Reveal key={service.key} delay={index * 0.08} className="h-full">
            <ServiceCard service={service} />
          </Reveal>
        ))}
      </div>

      <Disclaimer />
    </div>
  </section>
);
